var every = require('../array/virtual/every');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.every;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.every) ? every : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/every.js
// module id = 986
// module chunks = 0